import React, { memo } from "react";

import { Container } from "react-bootstrap";

import { exerciseApi } from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";

import ExerciseTabComponent from "../../../components/public/singleSimTabs/exercise";

import { TabContentSection } from "../styledSimContainer";
import LoadingComponent from "../../../components/public/loading";

const ExerciseTabContainer = ({
  simID,
  simSingleDetail,
  loading,
  error,
  errorMessage,
  simSrc,
  simulationData,
}) => {
  const {
    data: exercisePostData,
    error: exercisePostError,
    isLoaded: exerciseIsLoaded,
    isLoading: exerciseIsLoading,
    run: runPostExercise,
  } = useAxios({
    url: `${exerciseApi}${simID}/`,
    method: "post",
  });

  let element = null;
  if (loading) {
    element = <LoadingComponent />;
  } else if (error) {
    element = <p className="text-center fs-4 p-5">{errorMessage}🚶‍♂️</p>;
  } else if (!loading && !simSingleDetail.exerciseDetail) {
    element = <p className="text-center p-5">بزودی تمرین بارگذاری خواهد شد.</p>;
  } else if (simSingleDetail.exerciseDetail) {
    element = (
      <ExerciseTabComponent
        simID={simID}
        isExcel={simSingleDetail.simDetail.is_excel}
        ExerciseData={
          simSingleDetail.exerciseDetail ? simSingleDetail.exerciseDetail : []
        }
        simulationData={simulationData}
        simSrc={simSrc}
        postExerciseRequest={{
          exercisePostData,
          exercisePostError,
          exerciseIsLoaded,
          exerciseIsLoading,
          runPostExercise,
        }}
      />
    );
  }

  return (
    <TabContentSection className="py-3">
      <Container>{element}</Container>
    </TabContentSection>
  );
};
export default memo(ExerciseTabContainer);
